// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1lfyC","row":"Node_row__2_XFO","label":"Node_label__31f_x","footer":"Node_footer__2DKkf"};